import { API_STATES } from "@/helpers";

const state = {
  jobCodesGetState   : API_STATES.NOT_REQUESTED,
  jobCodeDeleteState : API_STATES.NOT_REQUESTED,
  jobCodesGetError   : null,
  jobCodeDeleteError : null,
  jobCodes           : [],
  jobCodeCreateState : API_STATES.NOT_REQUESTED,
  jobCodeCreateError : null,
  jobCodeUpdateState : API_STATES.NOT_REQUESTED,
  jobCodeUpdateError : null,
  jobCode            : {}
};

export default state;
